export default __webpack_public_path__ + "static/media/pokeball3c.e4a70e6a.png";